import React, { createContext, useEffect } from 'react';
import { ENVIRONMENT } from '@/environments/environment.ts';

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeContext = createContext<null>(null);

export function ThemeProvider({ children }: ThemeProviderProps) {
  // Apply theme based on system preference
  useEffect(() => {
    // If dark mode is not enabled via environment variable, always use light theme
    if (!ENVIRONMENT.enableDarkMode) {
      document.documentElement.classList.remove('dark');
      return;
    }

    // Check system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    document.documentElement.classList.toggle('dark', prefersDark);
    
    // Listen for changes in system preference
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = () => {
      document.documentElement.classList.toggle('dark', mediaQuery.matches);
    };
    
    mediaQuery.addEventListener('change', handleChange);
    
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return (
    <ThemeContext.Provider value={null}>
      {children}
    </ThemeContext.Provider>
  );
} 